export default "__VITE_ASSET__B$_0RprD__"